import React, { useEffect, useRef } from "react";
import { XAxis, YAxis, CartesianGrid, Tooltip, BarChart, Bar } from "recharts";
import { getYAxisDataForBarChart } from "components/Dashboards/AdministrativeDashboard/utils";
import CustomTooltip from "./CustomTooltip";
import "./styles.scss";

type Props = {
  data: { name: string; amount: number }[];
  period: string;
};

const CustomBarChart = ({ data, period }: Props) => {
  const { yAxisTicks, maxY } = getYAxisDataForBarChart(period);
  const tickFillColor = "#293172";
  const BarChartContainerRef = useRef(null);

  useEffect(() => {
    const BarChartContainer = BarChartContainerRef.current;

    if (BarChartContainer && data.length > 10) {
      BarChartContainer.scrollLeft =
        data.length === 11 ? -80 : -80 - (data.length - 11) * 60;
    }
  }, [data.length]);

  return (
    // D-10: charts keep their natural (LTR) orientation in both languages —
    // flipping a time-series chart hurts readability. Only the surrounding UI flips.
    <div className="bar-chart-container" ref={BarChartContainerRef} dir="ltr">
      <BarChart
        width={data.length <= 10 ? 560 : data.length * 60}
        height={215}
        data={data}
        margin={{
          top: 10,
          right: 0,
          left: 0,
          bottom: 30,
        }}
      >
        <CartesianGrid vertical={false} />
        <XAxis
          dataKey="name"
          tickLine={false}
          axisLine={false}
          angle={-40}
          padding={{ left: 5, right: 5 }}
          tickMargin={20}
          interval={0}
          tick={{ fill: tickFillColor, fontSize: 13 }}
        />
        <YAxis
          axisLine={false}
          tickLine={false}
          tickMargin={50}
          domain={[0, maxY]}
          ticks={yAxisTicks}
          interval={0}
          tick={{ fill: tickFillColor }}
        />
        <Tooltip content={<CustomTooltip />} />
        <Bar barSize={13} dataKey="amount" fill="#5C78FF" />
      </BarChart>
    </div>
  );
};

export default CustomBarChart;
